import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Link } from '@uhg-abyss/web/ui/Link';
import { ProcessingStatItem } from '../ProcessingStatsItem';

export const SuccessTransCount = ({
  procStatsList,
  onChildValueChange,
  service,
}) => {
  const handleTranAdd = (e) => {
    e.preventDefault();
    onChildValueChange('ADD');
  };
  const handlTotalTerms = (e) => {
    e.preventDefault();
    onChildValueChange('TRM');
  };
  const handlTotalChanges = (e) => {
    e.preventDefault();
    onChildValueChange('CHG');
  };
  const handleNoChanges = (e) => {
    e.preventDefault();
    onChildValueChange('NCH');
  };
  const handleAllChanges = (e) => {
    e.preventDefault();
    onChildValueChange('AT');
  };

  return service === 'gps' ? (
    <ProcessingStatItem title="Successful Transaction Count">
      <Layout.Group grow>
        <Table.Container title="">
          <Table.TableBody>
            <Table.Row>
              <Table.Cell>
                <b>Adds</b>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.adds}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Terms </b>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.terms}
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>
                <b>Changes</b>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.changes}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>No Changes</b>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.noChanges}
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>
                <Link onClick={handleAllChanges} href="#">
                  Total
                </Link>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.total}
              </Table.Cell>
            </Table.Row>
          </Table.TableBody>
        </Table.Container>
      </Layout.Group>
    </ProcessingStatItem>
  ) : (
    <ProcessingStatItem title="Successful Transaction Count">
      <Layout.Group grow>
        <Table.Container title="">
          <Table.TableBody>
            <Table.Row>
              <Table.Cell>
                <b>Subscriber Adds</b>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.subscriberAdds}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Dependent Adds </b>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.dependentAdds}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                {' '}
                <Link onClick={handleTranAdd} href="#">
                  Total Adds
                </Link>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.totalAdds}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Subscriber Terms Submitted</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.successfullTransactionCount
                    ?.subscriberTermsSubmitted
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Dependent Terms Submitted</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.successfullTransactionCount
                    ?.dependentTermsSubmitted
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Terms Submitted</b>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.termsSubmitted}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Subscriber Auto-Cancels</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.successfullTransactionCount
                    ?.subscriberAutoCancels
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Dependent Auto-Cancels</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.successfullTransactionCount
                    ?.dependentAutoCancels
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Auto-Cancels</b>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.autoCancels}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <Link onClick={handlTotalTerms} href="#">
                  Total Terms
                </Link>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.totalTerms}
              </Table.Cell>
            </Table.Row>
          </Table.TableBody>
        </Table.Container>
        <Table.Container title="">
          <Table.TableBody>
            <Table.Row>
              <Table.Cell>
                <b>Address</b>{' '}
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.address}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Coverage</b>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.coverage}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Demographic</b>{' '}
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.demographic}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <Link onClick={handlTotalChanges} href="#">
                  Total Changes
                </Link>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.totalChanges}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <Link onClick={handleNoChanges} href="#">
                  No Changes
                </Link>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.noChanges}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <Link onClick={handleAllChanges} href="#">
                  Total
                </Link>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.successfullTransactionCount?.total}
              </Table.Cell>
            </Table.Row>
          </Table.TableBody>
        </Table.Container>
      </Layout.Group>
    </ProcessingStatItem>
  );
};
